import { useMapSelectedVenue } from '@/contexts/MapSelectedVenue'
import { cva } from 'cva'
import { usePathname, useSearchParams } from 'next/navigation'
import { type FC } from 'react'
import { FontAwesomeIcon } from './FontAwesomeIcon'

const checkboxVariants = cva({
	base: 'w-6 h-6 rounded-xs border-(length:--stroke-sm) flex items-center justify-center',
	variants: {
		selected: {
			true: 'bg-blue border-blue text-white',
			false: 'border-grey-20',
		},
	},
})

type VenueFilterProps = {
	name: string
	value: string
	label: string
}

const VenueFilter: FC<VenueFilterProps> = ({ name, value, label }) => {
	const pathname = usePathname()
	const searchParams = useSearchParams()

	const values = searchParams.getAll(name)
	const selected = values.includes(value)

	const { selectedVenue, setSelectedVenue } = useMapSelectedVenue()

	const onClick = () => {
		const params = new URLSearchParams(searchParams)

		const newValues = values.includes(value)
			? values.filter((v) => v !== value)
			: [...values, value]

		params.delete(name)
		for (const value of newValues) {
			params.append(name, value)
		}

		const url = params.size > 0 ? `${pathname}?${params.toString()}` : pathname
		window.history.replaceState(null, '', url)

		// Deselect the venue
		if (selectedVenue) {
			setSelectedVenue(null)
		}
	}

	return (
		<li className="flex">
			<button type="button" className="inline-flex gap-sm cursor-pointer" onClick={onClick}>
				<div className={checkboxVariants({ selected })}>
					{selected && <FontAwesomeIcon icon={['fas', 'check']} size="xs" />}
				</div>
				<span className="text-body-small leading-[1.5]">{label}</span>
			</button>
		</li>
	)
}

export type VenueFiltersProps = {
	status: VenueFilterProps[]
}

export const VenueFilters: FC = () => {
	return (
		<div className="space-y-lg">
			<legend className="text-body-small font-bold">Venue Type</legend>
			<ul className="space-y-sm">
				<VenueFilter name="status" value="new" label="New" />
				<VenueFilter name="status" value="upgraded" label="Upgraded" />
			</ul>
		</div>
	)
}
